import constant from '@/common/resources/constant'

/**
 * cell mixin 에 있는 shaveUrl 메서드 분리
 * @param url
 * @returns {string|string|string}
 */
export const shaveUrl = (url = '') => {
  if (!url) {
    return ''
  }
  const patternsToRemove = [
    constant.URL_DOMAIN,
    constant.URL_PROTOCOL_DEEP_LINK,
    'www.wavve.com',
    'http://',
    'https://',
    '/index.html',
    '.html',
  ]

  return patternsToRemove.reduce((acc, cur) => acc.replace(cur, ''), url)
}
